import Gateway from '@nsoft/seven-gravity-gateway/slave';

let gateway;
export default {
  init() {
    return new Promise((resolve) => {
      gateway = Gateway({
        debug: false,
        slaveId: 'SBViews',
        load: (msg) => {
          resolve(msg.data);
        },
      });
    });
  },
  sendMessage(msg) {
    if (gateway) gateway.sendMessage({ action: msg.action, data: msg.data });
  },
};
